import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Auth.css';

function Signup({ onNavigate, ownerExists = false }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [accountName, setAccountName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (ownerExists) {
      setError('Owner setup is already complete. Ask the owner to grant editor access.');
      return;
    }

    // Validation
    if (password !== passwordConfirm) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 12) {
      setError('Password must be at least 12 characters');
      return;
    }

    setLoading(true);

    const result = await register(name, email, password, passwordConfirm, accountName || name);
    if (result.success) {
      onNavigate('dashboard');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Create Account</h2>
        {ownerExists && (
          <div className="error-message">
            Owner setup is already complete. Ask the owner to grant editor access.
          </div>
        )}
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={loading}
              readOnly={ownerExists}
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label>Account Name (optional):</label>
            <input
              type="text"
              value={accountName}
              onChange={(e) => setAccountName(e.target.value)}
              placeholder={name || 'Your account name'}
              disabled={loading}
              readOnly={ownerExists}
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              readOnly={ownerExists}
            />
          </div>
          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              minLength="12"
              maxLength="128"
              readOnly={ownerExists}
              autoComplete="new-password"
            />
          </div>
          <div className="form-group">
            <label>Confirm Password:</label>
            <input
              type="password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              required
              disabled={loading}
              minLength="12"
              maxLength="128"
              readOnly={ownerExists}
              autoComplete="new-password"
            />
          </div>
          <button type="submit" className="btn-primary" disabled={loading || ownerExists}>
            {loading ? 'Creating Account...' : 'Sign Up'}
          </button>
        </form>
        <p className="auth-toggle">
          Already have an account?{' '}
          <button 
            type="button" 
            className="link-button"
            onClick={() => onNavigate('login')}
          >
            Login
          </button>
        </p>
      </div>
    </div>
  );
}

export default Signup;
